import Banner from "@/components/landing/homeSeven/Banner";
import HowItsWork from "@/components/landing/homeSeven/HowItsWork";
import Testimonials from "@/components/landing/homeSeven/Testimonials";
import AppDownload from "@/components/landing/homeTwo/AppDownload";

export default function HomeSeven() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* How Its Work section */}
      <HowItsWork />

      {/* App Download section */}
      <AppDownload
        title="Control accepted payment methods from mobile"
        intro="Enable or pause rails, resend payment links, and reconcile deposits without opening your laptop."
        bullets={[
          "Switch methods per client or retainer agreement",
          "Instant push when a new local payment option goes live",
          "Refund or partial-capture straight from the activity feed",
        ]}
      />

      {/* Testimonials section */}
      <Testimonials
        title="Freelancers who diversified how they get paid"
        subtitle="Hear how teams lowered checkout drop-off by offering the methods their clients already trust."
      />
    </>
  );
}
